import type { Suggestion } from '../../api/datasets';
import { Badge } from '../ui';
import './SuggestionList.css';

const KIND_LABEL: Record<Suggestion['kind'], string> = {
  analysis: 'Question',
  quality: 'Data check',
  join: 'Other data',
};

const KIND_TONE: Record<Suggestion['kind'], 'brand' | 'warning' | 'neutral'> = {
  analysis: 'brand',
  quality: 'warning',
  join: 'neutral',
};

/**
 * Where to look next, proposed from the profile.
 *
 * Each entry leads with the question, not an answer: the reader decides whether
 * it is worth asking. A suggestion that carries its own caveat — a correlation,
 * a possible join — shows it right there, because that sentence is the
 * difference between a prompt and a wrong conclusion.
 */
export function SuggestionList({ suggestions }: { suggestions: Suggestion[] }) {
  return (
    <ul className="sc-suggestions">
      {suggestions.map((suggestion) => (
        <li key={suggestion.key} className="sc-suggestions__item">
          <div className="sc-suggestions__head">
            <h3 className="sc-suggestions__title">{suggestion.title}</h3>
            <Badge tone={KIND_TONE[suggestion.kind]}>{KIND_LABEL[suggestion.kind]}</Badge>
          </div>
          <p className="sc-suggestions__question">{suggestion.question}</p>
          <p className="sc-suggestions__basis">{suggestion.basis}</p>
          {suggestion.caveat && <p className="sc-suggestions__caveat">{suggestion.caveat}</p>}
        </li>
      ))}
    </ul>
  );
}
